export { VoiceSupportCardWaitlist } from './voice-support-card-waitlist.component';
